module.exports = new __parcel__URL__("coconut.69480f00.svg").toString();